import React, { Fragment, useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  IconButton,
  InputLabel,
  TextField,
  Box,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import mlsIcon from "../../../../assets/images/docs/mlsIcon.png";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import { useDispatch, useSelector } from "react-redux";
import { updateFolder } from "../../../../redux/docs";
import LoadingButton from "@mui/lab/LoadingButton";
import { toast } from "react-toastify";
function EditMls(props) {
  const { open, setOpen, classes, folderDetails } = props;
  const [mlsNumber, setMlsNumber] = useState(folderDetails?.mls_listing_id);
  const dispatch = useDispatch();
  const folderUpdate = useSelector((state) => state.Docs.folderUpdate);

  useEffect(() => {
    if (open) {
      setMlsNumber(folderDetails?.mls_listing_id);
    }
  }, [folderDetails, open]);

  const handleEditMls = () => {
    if (mlsNumber.trim() === "") {
      toast.error("Please enter a MLS number", { theme: "colored" });
      return;
    }
    dispatch(
      updateFolder({
        id: folderDetails?.id,
        schema: { mls_listing_id: mlsNumber },
        handleSuccess: () => {
          handleClose();
          toast.success("MLS number updated successfully", {
            theme: "colored",
          });
        },
        handleError: (error) => {
          toast.error(JSON.stringify(error), { theme: "colored" });
        },
      })
    );
  };

  const handleClose = () => {
    setOpen(false);
    setMlsNumber("");
  };
  return (
    <Fragment>
      <Dialog disablePortal open={open} fullWidth={true} maxWidth={"sm"}>
        <DialogTitle className={classes.modalHeader}>
          <Typography className={classes.modalTitle}>
            {" "}
            MLS Number: {folderDetails?.mls_listing_id}
          </Typography>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.modalContent}>
          <InputLabel className={classes.inputLabel}>
            Please add/edit the MLS number:
          </InputLabel>
          <Grid container spacing={3}>
            <Grid item xs={1}>
              <img
                src={mlsIcon}
                objectFit="contain"
                alt={"mls icon"}
                style={{ width: "32px", marginTop: "10px" }}
              />
            </Grid>
            <Grid item xs={11}>
              <TextField
                fullWidth
                size="small"
                className={classes.EditMlsField}
                value={mlsNumber}
                onChange={(e) => setMlsNumber(e.target.value)}
              />
              <Box className={classes.NoteSection}>
                <ErrorOutlineRoundedIcon sx={{ color: "#bababa" }} />
                <Typography className={classes.NoteSectionContent}>
                  This field is used to pull listing documents from the
                  corresponding MLS listing into the document folder.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ padding: "10px  20px 20px 0px" }}>
          <Button onClick={handleClose} className={classes.cancelButton}>
            Cancel
          </Button>
          <LoadingButton
            disabled={!Boolean(mlsNumber)}
            className={classes.doneButton}
            onClick={() => handleEditMls()}
            loading={folderUpdate.isLoading}
            loadingPosition="end"
          >
            Done
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
export default withStyles(styleSheet, { name: "EditMlsStyle" })(EditMls);
